import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PlatformIdentityService } from './services';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [CommonModule, IonicModule],
})
export class PlatformIdentityModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: PlatformIdentityModule,
      providers: [PlatformIdentityService],
    };
  }
}
